import src from "IMAGE";
export default { src, width: 94, height: 100, blurWidth: 0, blurHeight: 0};
